export const ROLE_TYPES = {
  APPSUMO: -1,
  BASIC: 0,
  PREMIUM: 1,
  PRO: 2,
  ELITE: 3,
}

export const roleTypes = [
  {
    id: 1,
    groupId: ROLE_TYPES.BASIC,
  },
  {
    id: 2,
    groupId: ROLE_TYPES.PREMIUM,
  },
  {
    id: 3,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 4,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 5,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 6,
    groupId: ROLE_TYPES.PREMIUM,
  },
  {
    id: 7,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 8,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 9,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 10,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 11,
    groupId: ROLE_TYPES.PREMIUM,
  },
  {
    id: 12,
    groupId: ROLE_TYPES.PREMIUM,
  },
  {
    id: 13,
    groupId: ROLE_TYPES.PREMIUM,
  },
  {
    id: 14,
    groupId: ROLE_TYPES.PREMIUM,
  },
  {
    id: 15,
    groupId: ROLE_TYPES.PRO,
  },
  {
    id: 16,
    groupId: ROLE_TYPES.PREMIUM,
  },
  {
    id: 17,
    groupId: ROLE_TYPES.PRO,
  },
  {
    id: 18,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 19,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 20,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 21,
    groupId: ROLE_TYPES.ELITE,
  },
  {
    id: 22,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 23,
    groupId: ROLE_TYPES.APPSUMO,
  },
  {
    id: 24,
    groupId: ROLE_TYPES.PREMIUM,
  },
]
